import React from 'react';
import { HeartIcon, QuoteIcon } from 'lucide-react';
import { fullTestimonials } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
export function FullTestimonials() {
  return <section className="mx-auto max-w-6xl px-4 py-14 md:py-16" data-id="element-113" data-mp="3dgpuyr3qhatc">
      <Eyebrow data-id="element-114" data-mp="3ierne2n1umhh">
        <span className="inline-flex items-center gap-2" data-id="element-115" data-mp="3ifawctuq20jd">
          <HeartIcon aria-hidden="true" className="h-4 w-4" data-id="element-116" data-mp="3igvpqg5avdfn" /> Más entrenadores que ya lo tienen
        </span>
      </Eyebrow>
      <SectionTitle data-id="element-117" data-mp="2ppu7g66b91rw">
        Lo que cambió en sus clases <span className="text-gold" data-id="element-118" data-mp="2pqm3tj7qf3j8">desde la primera semana</span>
      </SectionTitle>
      <div className="mt-10 grid items-stretch gap-4 md:grid-cols-2" data-id="element-119" data-mp="2uof9mb54hviz">
        {fullTestimonials.map((item, index) => <article key={item.initials + item.name} className={`relative flex flex-col rounded-2xl border bg-surface p-6 ${index === 0 ? 'border-gold/40 md:col-span-2' : 'border-line'}`} data-id="element-120" data-mp="2zpl3icairou3" data-mpi={index}>
            <QuoteIcon aria-hidden="true" className="absolute right-5 top-5 h-8 w-8 text-gold/20" data-id="element-121" data-mp="2ycayhphlhv14" />
            <p className="mb-4 text-sm text-gold" aria-label="5 de 5 estrellas" data-id="element-122" data-mp="2u9o69nh0i83e">
              ★★★★★
            </p>
            <blockquote className={`mb-6 flex-1 font-medium italic leading-relaxed text-zinc-300 ${index === 0 ? 'text-lg md:text-xl' : 'text-base'}`} data-id="element-123" data-mp="2pa1s9btd0ntj">
              “{item.text}”
            </blockquote>
            <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-124" data-mp="2am88dex8qz55">
              <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-gold/10 text-sm font-bold text-gold" data-id="element-125" data-mp="2akdrcbp3br6c">
                {item.initials}
              </span>
              <div data-id="element-126" data-mp="1wlnumx66ntii">
                <p className="text-sm font-bold text-white" data-id="element-127" data-mp="1rnchodkld2w2">{item.name}</p>
                <p className="text-xs text-zinc-500" data-id="element-128" data-mp="1ro4c3l2gcukr">📍 {item.place}</p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}